import Footer from "./Footer"
import Header from "./Header"
import Background from "./Background"

const Layout = ({children}) => {
    return(
        <>
            <Header />
            <Background />
            <main className="bc-main">
                {children}
            </main>
            <Footer />
        </>
    )
}

export default Layout